export const fetch = {
  pathname: ({ id, type }) => `/manage_sims/actions/filtered_actions.json?${type}=${encodeURIComponent(id)}`
}
